import React from "react";
import {Form, FormGroup, Input} from "reactstrap";
import FromValidationError from "./FormValidationError";


const SignUpForm = props => (
            <Form id="signUpForm" data-testid="signUpForm">
                <FormGroup>
                    <Input
                        className={"generic-input gap-top-4"}
                        data-testid="signUpForm.input.email"
                        type="email"
                        validations={['required', 'email']}
                        name="email"
                        value={props.email}
                        onChange={props.handleChange}
                        id="email"
                        placeholder="Email"
                    />
                    <FromValidationError field={props.validationErrors.email}/>
                </FormGroup>
                <FormGroup>
                    <Input
                        className={"generic-input gap-top-4"}
                        data-testid="signUpForm.input.password"
                        type="password"
                        validations={['required', 'password']}
                        name="password"
                        value={props.password}
                        onChange={props.handleChange}
                        id="password"
                        placeholder="Password"
                    />
                    <FromValidationError field={props.validationErrors.password}/>
                </FormGroup>
                <FormGroup>
                    <Input
                        className={"generic-input gap-top-4"}
                        data-testid="signUpForm.input.confirmPassword"
                        type="password"
                        validations={['confirmPassword']}
                        name="confirmPassword"
                        value={props.confirmPassword}
                        onChange={props.handleChange}
                        id="confirmPassword"
                        placeholder="Confirm Password"
                    />
                    <FromValidationError field={props.validationErrors.confirmPassword}/>
                </FormGroup>
                <div><p className={'error'} data-testid="signUpForm.error">{props.error}</p></div>
                <div className={"auth-form-buttons gap-top-4"}>
                    <button className="try-pi-btn auth-form-button-left" data-testid="signUpForm.button.signUp" onClick={props.signUp}>SIGN UP</button>
                    <button className="try-pi-btn auth-form-button-right short-text" data-testid="signUpForm.button.back" onClick={props.resetState}>BACK</button>
                </div>
            </Form>
        );
export default SignUpForm;